import { GetCompaniesPimsModel } from '../../pims/companies/model/get-companies-pims.model';

export class GetCompanyGroupedPimsCnpjIdModel {
  operatorId!: string;
  operatorName!: string;
  operatorPims: GetCompaniesPimsModel = new GetCompaniesPimsModel();
}
